// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 背调查询页面样式 */
.bc-container {
  max-width: 800px;
  margin: 20px auto;
  padding: 0 20px;
  padding-bottom: 180px;
}

.bc-card-header {
  display: flex;
  align-items: center;
  gap: 16px;
}

.bc-card-title {
  font-size: 18px;
  font-weight: bold;
}

.bc-form-description {
  text-align: center;
  color: #666;
  margin-bottom: 30px;
  font-size: 14px;
}

.bc-form-content {
  max-width: 500px;
  margin: 0 auto;
}

.bc-warning-tip {
  display: flex;
  align-items: flex-start;
  background-color: #fff8e6;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
}

.bc-warning-icon {
  color: #ff9500;
  font-size: 18px;
  margin-right: 12px;
  margin-top: 2px;
}

.bc-warning-text {
  flex: 1 1;
  color: #ff9500;
  font-size: 13px;
  line-height: 1.6;
}

/* 底部操作区域 */
.bc-bottom-action-area {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  padding: 16px 24px 24px;
  z-index: 100;
}

.bc-agreement-checkbox {
  margin-bottom: 16px;
  text-align: center;
}

.bc-agreement-text {
  font-size: 14px;
  color: #333;
}

.bc-action-bar {
  display: flex;
  gap: 12px;
  max-width: 500px;
  margin: 0 auto;
}

.bc-action-bar button {
  flex: 1 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/BackgroundCheck.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,yCAAyC;EACzC,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT","sourcesContent":["/* 背调查询页面样式 */\n.bc-container {\n  max-width: 800px;\n  margin: 20px auto;\n  padding: 0 20px;\n  padding-bottom: 180px;\n}\n\n.bc-card-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.bc-card-title {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.bc-form-description {\n  text-align: center;\n  color: #666;\n  margin-bottom: 30px;\n  font-size: 14px;\n}\n\n.bc-form-content {\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.bc-warning-tip {\n  display: flex;\n  align-items: flex-start;\n  background-color: #fff8e6;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 24px;\n}\n\n.bc-warning-icon {\n  color: #ff9500;\n  font-size: 18px;\n  margin-right: 12px;\n  margin-top: 2px;\n}\n\n.bc-warning-text {\n  flex: 1;\n  color: #ff9500;\n  font-size: 13px;\n  line-height: 1.6;\n}\n\n/* 底部操作区域 */\n.bc-bottom-action-area {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #fff;\n  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);\n  padding: 16px 24px 24px;\n  z-index: 100;\n}\n\n.bc-agreement-checkbox {\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n.bc-agreement-text {\n  font-size: 14px;\n  color: #333;\n}\n\n.bc-action-bar {\n  display: flex;\n  gap: 12px;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.bc-action-bar button {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
